import { useState } from "react";
import { apiFetch } from "../lib/api-client";
import { Dialog, PrimaryButton, QuietButton, Select } from "./controls";

export function JobCancellation({ appointmentId, appointmentLabel, cancelJob = false, onSaved }: { appointmentId: string; appointmentLabel: string; cancelJob?: boolean; onSaved: () => void | Promise<void> }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const title = cancelJob ? "Cancel job" : "Cancel appointment";
  const submit = async () => {
    if (busy || !reason) return;
    setBusy(true); setError("");
    try {
      const response = await apiFetch(`/api/v1/workspace/dispatch/appointments/${encodeURIComponent(appointmentId)}/status`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: cancelJob ? "cancel_visit" : "cancel_dispatch", reason }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error?.message || "Cancellation could not be saved.");
      setOpen(false);
      await onSaved();
    } catch (cause) { setError(cause instanceof Error ? cause.message : "Cancellation could not be saved."); }
    finally { setBusy(false); }
  };
  return <>
    <QuietButton type="button" aria-haspopup="dialog" onClick={() => { setReason(""); setError(""); setOpen(true); }}>{title}{cancelJob && <span aria-hidden="true"> ▾</span>}</QuietButton>
    {open && <Dialog title={title} onClose={() => { if (!busy) setOpen(false); }}>
      <div className="space-y-4">
        <p className="font-semibold">{appointmentLabel}</p>
        <p>{cancelJob ? "This marks the job canceled and cancels this appointment. Other appointment records, invoices, and history are retained." : "This cancels only this appointment. The job status and its other appointments stay unchanged."}</p>
        <Select label="Cancellation reason" value={reason} placeholder="Choose a reason" disabled={busy} onChange={setReason} options={[
          { value: "rescheduled", label: "Rescheduled" },
          { value: "customer_cancelled", label: "Customer canceled" },
          { value: "duplicate", label: "Duplicate" },
          { value: "no_longer_needed", label: "No longer needed" },
        ]} />
        {error && <p role="alert" className="job-error">{error}</p>}
        <div className="job-actions"><QuietButton type="button" disabled={busy} onClick={() => setOpen(false)}>Keep {cancelJob ? "job" : "appointment"}</QuietButton><PrimaryButton type="button" disabled={busy || !reason} onClick={() => void submit()}>{busy ? "Canceling…" : `Confirm ${cancelJob ? "job" : "appointment"} cancellation`}</PrimaryButton></div>
      </div>
    </Dialog>}
  </>;
}
